  
  import * as Yup from "yup";
  import { Message } from "rsuite";

  const handleNext = (currentStep, steps, setCurrentStep, toaster, formik) => {
    if (currentStep < steps.length) {
      switch (currentStep) {
        case 1:
        //   Yup.object()
        //     .shape({
        //       FirstName: Yup.string()
        //         .required("First name is required")
        //         .min(2, "First name must be at least 2 characters")
        //         .max(50, "First name must be at most 50 characters"),
        //       LastName: Yup.string()
        //         .required("Last name is required")
        //         .min(2, "Last name must be at least 2 characters")
        //         .max(50, "Last name must be at most 50 characters"),
        //       EmailAddress: Yup.string()
        //         .required("Email is required")
        //         .email("Invalid email address")
        //         .max(100, "Email must be at most 100 characters"),
        //       Title: Yup.string()
        //         .required("Title is required")
        //         .min(2, "Title must be at least 2 characters")
        //         .max(50, "Title must be at most 50 characters"),
        //       PhoneNo: Yup.string()
        //         .required("Phone number is required")
        //         .matches(/^[0-9]{10}$/, "Invalid phone number"),
        //       Skills: Yup.array()
        //         .required("Skills are required")
        //         .min(1, "At least one skill is required"),
        //       ProfilePicture: Yup.mixed().test(
        //         "file",
        //         "Profile picture is required",
        //         (value) => value !== null
        //       ),
        //       ResumeFilePath: Yup.mixed()
        //         .optional("Resume is required")
        //         .test("file", "Resume is required", (value) => value !== null),
        //       DOB: Yup.date()
        //         .required("Date of birth is required")
        //         .max(new Date(), "Date of birth must be in the past"),
        //       Gender: Yup.string().required("Gender is required"),
        //       EmergencyContactNumber: Yup.string().required(
        //         "Emergency contact is required"
        //       ),
        //       Address: Yup.string()
        //         .required("Address is required")
        //         .min(2, "Address must be at least 2 characters")
        //         .max(100, "Address must be at most 100 characters"),
        //       City: Yup.string()
        //         .required("City is required")
        //         .min(2, "City must be at least 2 characters")
        //         .max(50, "City must be at most 50 characters"),
        //       State: Yup.string()
        //         .required("State is required")
        //         .min(2, "State must be at least 2 characters")
        //         .max(50, "State must be at most 50 characters"),
        //       Country: Yup.string()
        //         .required("Country is required")
        //         .min(2, "Country must be at least 2 characters")
        //         .max(50, "Country must be at most 50 characters"),
        //       Bio: Yup.string().max(
        //         1000,
        //         "Bio must be at most 1000 characters"
        //       ),
        //     })
        //     .validate(formik.values)
        //     .then(() => {
          setCurrentStep(currentStep + 1);
            // })
            // .catch((errors) => {
            //   // Validation failed, display errors
            
            //   const message = (
            //     <Message showIcon type={"info"} closable>
            //       <strong>{errors.message}</strong>
            //     </Message>
            //   );
            //   toaster.push(message, { placement: "topCenter", duration: 5000 });
            // });
          break;

        case 2:
        //   Yup.object()
        //     .shape({
        //       EmployeeID: Yup.string()
        //         .required("Employee ID is required")
        //         .min(1, "Employee ID must be at least 2 characters")
        //         .max(50, "Employee ID must be at most 50 characters"),
        //       department: Yup.string()
        //         .required("Department is required")
        //         .min(2, "Department must be at least 2 characters")
        //         .max(50, "Department must be at most 50 characters"),
        //       Manager: Yup.string()
        //         .required("Manager is required")
        //         .min(2, "Manager must be at least 2 characters")
        //         .max(50, "Manager must be at most 50 characters"),
        //       startdate: Yup.date().required("Start date is required"),
        //       // lastdate: Yup.date()
        //       // .required('Last date is required'),
        //       Status: Yup.string().required("Employment status is required"),
        //       Salary: Yup.number()
        //         .required("Salary is required")
        //         .min(0, "Salary must be a positive number"),
        //       PayFrequency: Yup.string().required("Pay frequency is required"),

        //       PreferedLanguage: Yup.string()
        //         .required("Preferred language is required")
        //         .min(2, "Preferred language must be at least 2 characters")
        //         .max(50, "Preferred language must be at most 50 characters"),
        //       Prefereddistancefromhome: Yup.number(
        //         "Preferred distance must be a number"
        //       ).required("Preferred distance is required"),
        //       employee_Heighers: Yup.array()
        //         .of(
        //           Yup.object({
        //             university: Yup.string().required(
        //               "University name is required"
        //             ),
        //             highestQualification: Yup.string().required(
        //               "Qualification is required"
        //             ),
        //             startDate: Yup.date().required("Start date is required"),
        //             endDate: Yup.date().required("End date is required"),
        //             certifications: Yup.string().optional(
        //               "certifications is required"
        //             ),
        //             fieldofstudy: Yup.string().required(
        //               "Field of study is required"
        //             ),
        //             percentage: Yup.string().required("Percentage is required"),
        //           })
        //         )
        //         .min(1, "At least one education is required"),
        //     })
        //     .validate(formik.values)
        //     .then(() => {
          setCurrentStep(currentStep + 1);
            // })
            // .catch((errors) => {
            //   // Validation failed, display errors
           
            //   const message = (
            //     <Message showIcon type={"info"} closable>
            //       <strong>{errors.message}</strong>
            //     </Message>
            //   );
            //   toaster.push(message, { placement: "topCenter", duration: 5000 });
            // });
          break;
      }
    }
  };

  const handleBack = (currentStep, setCurrentStep) => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  export { handleNext, handleBack };